export default '1.25';